export default __webpack_public_path__ + "7fa9f0bd0b6503e17447356af68658dd.svg";